import { render } from "./HeroiconsOutlineLink.vue?vue&type=template&id=ab77180e"
const script = {}

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLink.vue"]])

export default __exports__